import BackNavigationArrow from "@/components/views/BackNavigationArrow";
import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { Card } from "antd";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";
import { Permission } from "../../../../common/security/enums";
import { hasAllPermissions, hasPermission } from "../../../../common/security/utils";
import { usePermissions } from "../../../auth/hooks";
import { CalcType } from "../../enums";
import { CreateCalcSettingsForm } from "../components/forms/CreateCalcSettingsForm";

export const CalcSettingsCreateContainer = () => {
  const { t } = useTranslation();

  const [urlParams] = useSearchParams();
  const calcType = urlParams.get("calcType") as CalcType | null;

  const permissions = usePermissions();

  const allowedTypes = [
    ...(hasPermission(permissions, Permission.ADMIN_MTPL_CALCULATORS) ? [CalcType.MTPL] : []),
    ...(hasPermission(permissions, Permission.ADMIN_CRASH_CALCULATORS) ? [CalcType.CRASH] : []),
    ...(hasAllPermissions(permissions, [Permission.ADMIN_MTPL_CALCULATORS, Permission.ADMIN_CRASH_CALCULATORS])
      ? [CalcType.MTPL_CRASH]
      : []),
    ...(hasPermission(permissions, Permission.ADMIN_CRASH_CALCULATORS) ? [CalcType.GAP, CalcType.PAS] : []),
    ...(hasPermission(permissions, Permission.ADMIN_REALTY_CALCULATORS) ? [CalcType.REALTY] : []),
    ...(hasPermission(permissions, Permission.ADMIN_TRAVEL_CALCULATORS) ? [CalcType.TRAVEL] : []),
  ];
  const initialCalcType = calcType && allowedTypes.includes(calcType) ? calcType : allowedTypes[0];

  return (
    <ContentWrapper>
      {initialCalcType && (
        <Card
          className="card-box"
          title={
            <BackNavigationArrow>
              <h2>{t("calc.settings.titles.new", { calcType: t("calc.enums.calcType." + initialCalcType) })}</h2>
            </BackNavigationArrow>
          }
        >
          <CreateCalcSettingsForm calcType={initialCalcType} />
        </Card>
      )}
    </ContentWrapper>
  );
};
